"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATSIG_FEATURE_GATES_LOCAL_VALUE = exports.STATSIG_FEATURE_GATES = void 0;
exports.STATSIG_FEATURE_GATES = {
    TEST_AC_GATE: 'test_cms_feature_gate',
    ENABLE_CONVERSATION_ASSISTANT: 'enable_conversation_assistant',
    ENABLE_SUPPORT_TICKET_NAV: 'enable_in_app_notification',
    ENABLE_INCREMENTAL_LOADING_SUBS: 'enable_incremental_loading_of_subs_in_ecc',
    ENABLE_FINALIZE_QUOTE_ERROR_FOR_EXPIRED_PRICING_PLANS: 'finalize_quote_for_expired_pricing_plan',
    ENABLE_ENTERPRISE_REFUND: 'ac_enable_enterprise_refund',
    ENABLE_FREE_TO_ANNUAL_PAID_QUOTING_V2: 'ac_enable_free_to_annual_paid_quoting_v2',
    ENABLE_ROVO_IN_NATIVE_CATALOG_SXP: 'enable_rovo_in_seller_experience',
    ENABLE_SANDBOX_DECOUPLING: 'ac_sandbox-decoupling',
    ENABLE_FETCH_ALL_OFFERINGS_FOR_QUOTE_LINE_ITEMS: 'sxp_fetch-all-offerings',
    ENABLE_SANDBOX_SUPPORT_IN_ECC_UI: 'enable_sandbox_support_in_ecc',
    ENABLE_FUTURE_DATED_ENTITLEMENT_ECC_BACKEND: 'enable_future_dated_entitlement_ecc_backend',
    ENABLE_PROMOTIONS_DISCOUNT_MODAL: 'enable-promotions-discount-modal',
    ENABLE_THROW_ERROR_ON_EMPTY_HYDRA_FILTERS: 'enable_throw_error_on_empty_hydra_filters',
    ENABLE_POA_DESTROY_ENTITLEMENT_ENDPOINT: 'enable-poa-destroy-entitlement-endpoint',
    ENABLE_TEAM_WORK_COLLECTION: 'ac_enable_team_work_collection',
    ENABLE_FUTURE_DATES_FOR_NEW_PRODUCTS: 'enable-future-dates-for-new-products',
    ENABLE_BILLING_ANCHOR_CHANGE_FOR_SCHEDULED_CANCEL: 'enable_billing_anchor_change_for_scheduled_cancel',
    ENABLE_TASK_MANAGER_V2: 'enable_task_manager_v2',
    ENABLE_ALL_INVOICE_GROUPS_FETCH: 'ac_enable_all_invoice_groups_fetch',
    ENABLE_EXTENDED_SEARCH_OPTIONS: 'apd_enable_extended_search_options_v2',
    ENABLE_RECENTLY_VISITED_HISTORY: 'ac_enable_recently_visited_history',
    ENABLE_WAC_RESELLER: 'ac_enable_wac_reseller',
    ENABLE_SHIP_TO_PARTY_MEMOIZE: 'enable_memoize_ship_to_party_call',
    ENABLE_PRICING_PLAN_RESET_ON_PRICING_TYPE_IG_CHANGE: 'sxp_pricing-plan-reset-on-pricing-type-ig-change',
    ENABLE_QUOTE_EXTENSION_APPROVAL_FLOW_V2: 'apd_enable_quote_extension_approval_flow_v2',
    ENABLE_ORDER_HISTORY_DETAIL_VIEW_MORE: 'ac_enable_order_history_detail_view_more',
    ENABLE_TXA_TRANSFER_WITH_IG_FOR_FREE: 'enable_txa_transfer_with_ig_for_free_in_uof',
    ENABLE_BILLING_CLOCKID_FIELD: 'ac_enable_billing_clock_id_field',
    ENABLE_JPY_CURRENCY: 'ac_enable_jpy_currency',
    ENABLE_JPY_CURRENCY_M2: 'ac_enable_jpy_currency_m2',
    ENABLE_LOOM_ENTITLEMENT: 'ac_enable_loom_entitlement',
    ENABLE_ENTITLEMENT_DETAIL_LOADING: 'enable_entitlement_detail_loading',
    ENABLE_LINKED_ENTITLEMENT_ENRICHMENT: 'ac_enable_linked_entitlement_enrichment',
    ENABLE_IN_APP_NOTIFICATION: 'ac_enable_inapp_notifications',
    ENABLE_CANCEL_PREDUNNING: 'ac_enable_cancel_predunning',
    ENABLE_REACTIVATION_PANE_FOR_SANDBOX: 'ac_enable_reactivation_pane_for_sandbox',
    ENABLE_CHANGE_BILL_DATE_FOR_ANNUAL_TERM: 'ac_enable_change_bill_date_for_annual_term',
    ENABLE_PRIMARY_CUSTOMER_CONTACT: 'enable_primary_customer_contact',
    ENABLE_POA_NEW_ENTITLEMENT_ACTIVATION: 'ac_enable_poa_new_entitlement_activation',
    ENABLE_BILLING_PROFILES_CCP_SEARCH: 'ac_enable_billing_profiles_ccp_search',
    ENABLE_CASSI_PAGES_MIGRATION: 'enable-cassi-pages-migration-in-ac',
    ENABLE_RELATIONSHIP_FOR_STATUS_PAGE_ADDONS: 'ac_enable_relationship_for_status_page_addons',
    ENABLE_ESTIMATE_FOR_TRASNFER_WITHOUT_PAYMENT: 'ac_enable_estimate_for_transfer_without_payment',
    ENABLE_TWC_NON_CONVERTING_TRIAL: 'ac_enable_twc_non_converting_trial',
    ENABLE_QUOTE_V2_BILLING_CLOCK: 'sxp_enable_quote_v2_billing_clock',
    ENABLE_ENTERPRISE_SUPPORT_M2_3: 'ac_enable_enterprise_support_m2_3',
    ENABLE_MANUAL_BILLING: 'ac_enable_manual_billing',
    ENABLE_CCP_SEARCH_FOR_QUOTES: 'sxp_enable_ccp_search_for_quotes',
    ENABLE_REINVOICING: 'ac_enable_reinvoicing',
    ENABLE_DUNNING: 'ac_enable_dunning',
    ENABLE_MULTI_INSTANCE_APP: 'ac_multi_instance_app',
    ENABLE_JPD_PREMIUM: 'ac_enable_jpd_premium',
    ENABLE_VENDOR_NAME_IN_CATALOGUE: 'ac_enable_vendor_name_in_catalogue',
    ENABLE_ORDER_NUMBER_SEARCH: 'ac_enable_order_number_search',
    ENABLE_AUTO_SUGGEST: 'ac_enable_auto_suggest',
    ENABLE_AI_CHAT: 'ac_enable_ai_chat',
    ENABLE_ACTIVITY_TRACKING: 'ac_enable_activity_tracking',
    ENABLE_CATALOGE_PAGE_FILTER_PRODUCT_AND_APP: 'ac_enable_catalogue_page_filter_product_and_app',
    ENABLE_ADD_NEW_PRODUCTS_APPS_TO_QUOTE: 'sxp_enable_add_new_products_apps_to_quote',
    ENABLE_DUNNING_WITH_CREDITS: 'ac_enable_dunning_with_credits',
    DISABLE_SITE_MANAGE_ACTION: 'ans_disable_site_manage_action',
    ENABLE_LINKED_SUBSCRIPTIONS_FOR_TABLE: 'ac_enable_linked_subscriptions_for_table',
    ENABLE_REMOVE_PROMOTION_API: 'ac_enable_remove_promotion_api',
    ENABLE_STANDALONE_LOOM: 'enable_standalone_loom',
    ENABLE_EMAILS_IMPROVEMENT: 'ac_enable_emails_improvement',
    ENABLE_AC_INVOICE_PARTIAL_REFUND: 'ac_enable_invoice_partial_refund',
    ENABLE_SEND_NEXT_BILLING_TIMESTAMP_AS_ENDTIMESTAMP: 'enable_send_next_biiling_timestamp_as_endtimestamp',
    ENABLE_INSTANCE_USER_TIER: 'ac_enable_instance_user_tier',
    ENABLE_INSTANCE_END_DATE: 'ac_enable_instance_end_date',
    ENABLE_EVE_V2_API: 'ac_enable_eve_v2_api',
    ENABLE_ADD_ONS: 'ac_enable_add_ons',
    ENABLE_REPORT_ERROR: 'ac_enable_report_error',
    ENABLE_ENTITY_FEEDBACK: 'ac_enable_entity_feedback',
    ENABLE_DYNAMIC_SEARCH_INVOICE_GROUP: 'ac_enable_dynamic_search_invoice_group',
    ENABLE_CONTACT_PAGE_SUBSCRIPTION_TAB_ENHANCEMENT: 'enable_contact_page_subscription_tab_enhancement',
    ENABLE_DECOUPLING_END_DATES_FOR_QUOTES: 'decoupling-end-date-for-quotes',
    ENABLE_DIFFERENT_END_DATES_FOR_APP: 'enable-different-end-dates-for-app',
    ENABLE_QAD_FOR_SWEEP_IN_ENTERPRISE_INSTANCE: 'enable_qad_for_sweep_in_enterprise_instance_quote',
    ENABLE_BILLING_CYCLE_CHANGE_IN_REACTIVATION: 'ac_enable_billing_cycle_change_in_reactivation',
    ENABLE_SWEEPIN_WITHOUT_ENTERPRISE_PARENT_SELECTION: 'enable_sweepin_without_enterprise_parent_selection',
    PROVISIONING_CONTRACT_UPDATES_FIXES: 'ac_provisioning_contract_updates_fixes',
    ENABLE_FUTURE_DATE_FOR_FREE_TO_ANNUAL_PAID: 'enable_future_date_for-free-to-annual-paid',
    ENABLE_ENTERPRISE_SUPPORT_M2: 'ac_enable_enterprise_support_m2',
    ENABLE_INVOICE_ENRICHMENT: 'ac_enable_invoice_enrichment',
    ENABLE_CYCLE_SELECTION_ON_BILLING_DETAILS: 'ac_enable_cycle_selection_on_billing_details',
    ENABLE_PRE_BILLING_ANNUAL_EVERGREEN: 'sxp_enable_pre_billing_for_annual_evergreen',
    ENABLE_SUPPORT_SERVICE_BLAZE_CACHE: 'enable_support_service_blaze_cache',
    ENABLE_QUOTE_REFRESH_FOR_SAME_COMPUTED_REQUESTED: 'sxp_enable_quote_refresh_for_computed_requested',
    ENABLE_ENTITLEMENT_APPROVAL_FLOW_V2: 'apd_enable_entitlement_approval_flow_v2',
    ENABLE_APPROVAL_DESK_V2: 'apd_enable_approval_desk_v2',
    ENABLE_REFUND_APPROVAL_FLOW_V2: 'apd_enable_refund_approval_flow_v2',
    ENABLE_HIGH_TOUCH_QUOTE_DISCOUNT_APPROVAL_FLOW: 'apd_enable_high_touch_quote_discount_approval_flow',
    ENABLE_QUOTE_DISCOUNT_APPROVAL_FLOW_V2: 'apd_enable_quote_discount_approval_flow_v2',
    ENABLE_SUBMIT_QUOTE_APPROVAL: 'sxp_enable_submit_quote_approval',
    ENABLE_PAYMENT_AGAINST_UNCOLLECTIBLE_INVOICES: 'ac_enable_payment_against_uncollectible_invoices',
    ENABLE_FLAT_DISCOUNTS: 'ac_enable_flat_discounts',
    ENABLE_FINALIZE_QUOTE_LIST_PRICE_CHECK: 'sxp_enable_finalize_quote_list_price_check',
    ENABLE_BCA_FOR_ANNUAL_TRIAL_STANDALONE: 'enable-bca-change-annual-trial-standalone',
    ENABLE_CCP_SEARCH_FOR_PROMOTION_DATA: 'ac_enable_ccp_search_for_promotion_data',
    ENABLE_MARK_FAVORITE: 'ac_enable_mark_favourite',
    ENABLE_TICKET_CREATION_IN_REPORTING: 'ac_enable_ticket_creation_in_reporting',
    ENABLE_PUSH_NOTIFICATION_SUBSCRIPTION: 'ac_enable_push_notification_subscription',
    ENABLE_STEP_UP_CREDIT: 'ac_enable_step_up_credit',
    REMOVE_HYDRA_QUERY_IN_QUOTES: 'sxp_remove_hydra_queries_in_quotes',
    ENABLE_SPORK_CHANGES: 'ac_enable_spork_changes',
    ENABLE_REFUND_ENRICHMENT: 'ac_enable_refund_enrichment',
    ENABLE_COBILL_NEW_BILL_DATE: 'ac_enable_cobill_new_bill_date',
    ENABLE_SOFT_LIMITS: 'ac_enable_soft_limits',
    ENABLE_BULK_ALIGN_START_DATE: 'ac_enable_bulk_align_start_date',
    ENABLE_COLLECTION_UNWIND_CANCELLATION: 'ac_enable_cancel_unwind_collection',
    ENABLE_COLLECTION_REACTIVATION: 'ac_enable_collection_reactivation',
    ENABLE_QUOTE_FOR_DEACTIVATED_ENTITLEMENT: 'enable-quote-for-deactivated-entitlement',
    ENABLE_CCP_ORCHESTRATION_SOFT_LIMITS: 'ccp-orchestration-soft-limits',
    ENABLE_STATUSPAGE_TO_TRAVERSE_API: 'ac_enable_statuspage_to_traverse_api',
    ENABLE_NEW_STORE_CONFIGURATIONS_FOR_QUOTE: 'ac_enable_quote_configuration',
    ENABLE_INTERNAL_PARTNER_USAGE_CHECKBOX: 'ac_enable_internal_partner_usage_checkbox',
    ENABLE_ORDER_DETAILS_NEW_VIEW: 'ac_enable_order_details_new_view',
    ENABLE_PARENT_APP_PLAN_FOR_MULTI_INSTANCE: 'ac_enable_parent_app_plan_for_multi_instance',
    ENABLE_SANDBOX_AMENDMENTS: 'ac_sandbox_amendments',
};
exports.STATSIG_FEATURE_GATES_LOCAL_VALUE = {
    [exports.STATSIG_FEATURE_GATES.TEST_AC_GATE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CONVERSATION_ASSISTANT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SUPPORT_TICKET_NAV]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_FINALIZE_QUOTE_ERROR_FOR_EXPIRED_PRICING_PLANS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ENTERPRISE_REFUND]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_FREE_TO_ANNUAL_PAID_QUOTING_V2]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ROVO_IN_NATIVE_CATALOG_SXP]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SANDBOX_DECOUPLING]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SANDBOX_SUPPORT_IN_ECC_UI]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_WAC_RESELLER]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_PROMOTIONS_DISCOUNT_MODAL]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_FETCH_ALL_OFFERINGS_FOR_QUOTE_LINE_ITEMS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_THROW_ERROR_ON_EMPTY_HYDRA_FILTERS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_POA_DESTROY_ENTITLEMENT_ENDPOINT]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_TEAM_WORK_COLLECTION]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_FUTURE_DATES_FOR_NEW_PRODUCTS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_BILLING_ANCHOR_CHANGE_FOR_SCHEDULED_CANCEL]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_TASK_MANAGER_V2]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ALL_INVOICE_GROUPS_FETCH]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_EXTENDED_SEARCH_OPTIONS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_RECENTLY_VISITED_HISTORY]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SHIP_TO_PARTY_MEMOIZE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_TXA_TRANSFER_WITH_IG_FOR_FREE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_PRICING_PLAN_RESET_ON_PRICING_TYPE_IG_CHANGE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_QUOTE_EXTENSION_APPROVAL_FLOW_V2]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ORDER_HISTORY_DETAIL_VIEW_MORE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_INCREMENTAL_LOADING_SUBS]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_BILLING_CLOCKID_FIELD]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_JPY_CURRENCY]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_JPY_CURRENCY_M2]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_LOOM_ENTITLEMENT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ENTITLEMENT_DETAIL_LOADING]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_LINKED_ENTITLEMENT_ENRICHMENT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_IN_APP_NOTIFICATION]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CANCEL_PREDUNNING]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_REACTIVATION_PANE_FOR_SANDBOX]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CHANGE_BILL_DATE_FOR_ANNUAL_TERM]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_PRIMARY_CUSTOMER_CONTACT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_POA_NEW_ENTITLEMENT_ACTIVATION]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_BILLING_PROFILES_CCP_SEARCH]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CASSI_PAGES_MIGRATION]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_RELATIONSHIP_FOR_STATUS_PAGE_ADDONS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ESTIMATE_FOR_TRASNFER_WITHOUT_PAYMENT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_TWC_NON_CONVERTING_TRIAL]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_REINVOICING]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CATALOGE_PAGE_FILTER_PRODUCT_AND_APP]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ADD_NEW_PRODUCTS_APPS_TO_QUOTE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_MANUAL_BILLING]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_JPD_PREMIUM]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_VENDOR_NAME_IN_CATALOGUE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ORDER_NUMBER_SEARCH]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_AUTO_SUGGEST]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_AI_CHAT]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ACTIVITY_TRACKING]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_REMOVE_PROMOTION_API]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CCP_SEARCH_FOR_QUOTES]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_QUOTE_V2_BILLING_CLOCK]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ENTERPRISE_SUPPORT_M2_3]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_STANDALONE_LOOM]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_EMAILS_IMPROVEMENT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_DUNNING_WITH_CREDITS]: true,
    [exports.STATSIG_FEATURE_GATES.DISABLE_SITE_MANAGE_ACTION]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_LINKED_SUBSCRIPTIONS_FOR_TABLE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_DUNNING]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_MULTI_INSTANCE_APP]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_AC_INVOICE_PARTIAL_REFUND]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SEND_NEXT_BILLING_TIMESTAMP_AS_ENDTIMESTAMP]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_INSTANCE_USER_TIER]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_INSTANCE_END_DATE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_EVE_V2_API]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ADD_ONS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_REPORT_ERROR]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ENTITY_FEEDBACK]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_DYNAMIC_SEARCH_INVOICE_GROUP]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CONTACT_PAGE_SUBSCRIPTION_TAB_ENHANCEMENT]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_DECOUPLING_END_DATES_FOR_QUOTES]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_QAD_FOR_SWEEP_IN_ENTERPRISE_INSTANCE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_BILLING_CYCLE_CHANGE_IN_REACTIVATION]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SWEEPIN_WITHOUT_ENTERPRISE_PARENT_SELECTION]: true,
    [exports.STATSIG_FEATURE_GATES.PROVISIONING_CONTRACT_UPDATES_FIXES]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_FUTURE_DATE_FOR_FREE_TO_ANNUAL_PAID]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ENTERPRISE_SUPPORT_M2]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_INVOICE_ENRICHMENT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CYCLE_SELECTION_ON_BILLING_DETAILS]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_PRE_BILLING_ANNUAL_EVERGREEN]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SUPPORT_SERVICE_BLAZE_CACHE]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_QUOTE_REFRESH_FOR_SAME_COMPUTED_REQUESTED]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ENTITLEMENT_APPROVAL_FLOW_V2]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_APPROVAL_DESK_V2]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_REFUND_APPROVAL_FLOW_V2]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_HIGH_TOUCH_QUOTE_DISCOUNT_APPROVAL_FLOW]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_QUOTE_DISCOUNT_APPROVAL_FLOW_V2]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SUBMIT_QUOTE_APPROVAL]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_PAYMENT_AGAINST_UNCOLLECTIBLE_INVOICES]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_FLAT_DISCOUNTS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_FINALIZE_QUOTE_LIST_PRICE_CHECK]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_BCA_FOR_ANNUAL_TRIAL_STANDALONE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CCP_SEARCH_FOR_PROMOTION_DATA]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_TICKET_CREATION_IN_REPORTING]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_PUSH_NOTIFICATION_SUBSCRIPTION]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_STEP_UP_CREDIT]: true,
    [exports.STATSIG_FEATURE_GATES.REMOVE_HYDRA_QUERY_IN_QUOTES]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SPORK_CHANGES]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_REFUND_ENRICHMENT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_COBILL_NEW_BILL_DATE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SOFT_LIMITS]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_BULK_ALIGN_START_DATE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_COLLECTION_UNWIND_CANCELLATION]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_COLLECTION_REACTIVATION]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_QUOTE_FOR_DEACTIVATED_ENTITLEMENT]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_CCP_ORCHESTRATION_SOFT_LIMITS]: false,
    [exports.STATSIG_FEATURE_GATES.ENABLE_STATUSPAGE_TO_TRAVERSE_API]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_DIFFERENT_END_DATES_FOR_APP]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_NEW_STORE_CONFIGURATIONS_FOR_QUOTE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_INTERNAL_PARTNER_USAGE_CHECKBOX]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_ORDER_DETAILS_NEW_VIEW]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_PARENT_APP_PLAN_FOR_MULTI_INSTANCE]: true,
    [exports.STATSIG_FEATURE_GATES.ENABLE_SANDBOX_AMENDMENTS]: true,
};
